/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs */

const en_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales, fees and ad spend in one view, refreshed daily.`)
};

const ar_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المبيعات والرسوم والإنفاق الإعلاني في عرض واحد، يحدث يوميا.`)
};

const bn_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিক্রি, ফি আর বিজ্ঞাপন খরচ এক দৃশ্যে, প্রতিদিন তাজা।`)
};

const de_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz, Gebühren und Werbekosten in einer Ansicht, täglich aktualisiert.`)
};

const es_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventas, comisiones y gasto en anuncios en una vista, actualizada a diario.`)
};

const fr_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventes, frais et dépenses publicitaires dans une vue, actualisée chaque jour.`)
};

const pt_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendas, taxas e gasto em anúncios numa vista, atualizada todos os dias.`)
};

const zh_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售额、佣金和广告花费一个视图看完，每天更新。`)
};

const tr_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satış, komisyon ve reklam harcaması tek görünümde, günlük tazelenir.`)
};

const ru_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продажи, комиссии и рекламные траты в одном виде, обновляется ежедневно.`)
};

const pl_svc_ecommerce_amazon_tools_dash_desc4 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedaż, prowizje i wydatki reklamowe w jednym widoku, odświeżane codziennie.`)
};

/**
* | output |
* | --- |
* | "Sales, fees and ad spend in one view, refreshed daily." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_dash_desc4 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Dash_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_dash_desc4(inputs)
	return en_svc_ecommerce_amazon_tools_dash_desc4(inputs)
});
export { svc_ecommerce_amazon_tools_dash_desc4 as "svc_ecommerce-amazon-tools_DASH_desc" }